module.exports = __webpack_public_path__ + "img/title.c23d3f51.png";